export default __webpack_public_path__ + "b926a51d0b35d066c9cef355bc99722a.png";